// reportUtils.ts
import { toast } from 'react-toastify';

import axios from 'axios';
import qs from 'querystring';

import api from '~/services/api';

import { t } from '.';

export const openWithHeaders = (url, headers) => {
  const params = new URLSearchParams(url.split('?')[1]);

  // Cria um formulário dinâmico
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url.split('?')[0];
  form.target = '_blank'; // Abre em uma nova janela/aba

  params.forEach((value, key) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  // Adiciona os headers como campos ocultos
  for (const [key, value] of Object.entries(headers)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  }

  // Adiciona o formulário ao DOM, envia e remove
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export async function visualizarCO(idatendimento, token) {
  try {
    const relatorio = 'controleoperacao';
    const REACT_APP_URL_DOWNLOAD = sessionStorage.getItem('URL_REPORT')
      ? sessionStorage.getItem('URL_REPORT')
      : process.env.REACT_APP_URL_DOWNLOAD;
    const forms = { idatendimento };

    const response = async () => {
      const url = new URL(REACT_APP_URL_DOWNLOAD);
      url.search = new URLSearchParams({
        relatorio,
        ...JSON.parse(JSON.stringify(forms)),
      });

      const res = await axios({
        url: url.href,
        method: 'GET',
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res;
    };
    const resp = await response();

    const url = resp.config.url.href ?? resp.config.url;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    openWithHeaders(url, headers);
  } catch (err) {
    toast.error(t(err));
  }
}

/**
 * Função genérica para gerar e abrir um relatório em uma nova aba.
 * @param {object} options - Objeto de configurações.
 * @param {string} options.endpoint - O caminho específico da API para o
 * relatório.
 * @param {object} options.params - Um objeto contendo todos os parâmetros da
 * requisição para o backend. O objeto 'relatorio' dentro de 'params' será
 * JSON.stringified automaticamente. Os parâmetros devem ser assim:
 * const params = {
 *  fieldlist: 'id, nome, etc...', --> Obrigatório!
 *  wherefield: ['id', 'nome', etc...],
 *  typewherefield: ['EQUALS', 'EQUALS', etc..],
 *  valuewherefield: [1, 'Fulano', etc..],
 *  ... e todos os outros campos em buscaTodos
           relatorio: {
             formato, --> Obrigatório estar preenchido com 'pdf' ou 'excel' (
             Pode ser 'EXCEL' ou 'PDF')
             tituloRelatorio: 'Relatório', --> Obrigatório!
             substituirHeader: {
               nome: 'Quero outro header',
             },
           },
         };
 *
 */
export async function generateReport({ endpoint, params, compactQuery = false }) {
  const axiosParams = { ...params };
  if (
    !endpoint ||
    !axiosParams.relatorio ||
    !axiosParams.relatorio.formato ||
    (axiosParams.relatorio.formato.toLowerCase() !== 'pdf' &&
      axiosParams.relatorio.formato.toLowerCase() !== 'excel') ||
    !axiosParams.relatorio.tituloRelatorio ||
    !axiosParams.fieldlist
  ) {
    throw new Error(
      'Para gerar o relatório é necessário enviar o endpoint e os parâmetros ' +
        'fieldlist, e um objeto relatório com o formato e o título do mesmo!'
    );
  }

  const formato = axiosParams.relatorio.formato.toLowerCase();
  const { tituloRelatorio } = axiosParams.relatorio;

  if (axiosParams.relatorio.substituirHeader) {
    axiosParams.relatorio.substituirHeader = JSON.stringify(
      axiosParams.relatorio.substituirHeader
    );
  }

  axiosParams.relatorio = JSON.stringify(axiosParams.relatorio);

  const buildReducedQueryParams = () => {
    const relatorio = JSON.parse(axiosParams.relatorio);

    return {
      fieldlist: axiosParams.fieldlist,
      wherefield: axiosParams.wherefield,
      typewherefield: axiosParams.typewherefield,
      valuewherefield: axiosParams.valuewherefield,
      filteruser: axiosParams.filteruser,
      filterveic: axiosParams.filterveic,
      orderfield: axiosParams.orderfield,
      ordination: axiosParams.ordination,
      pesquisalista: axiosParams.pesquisalista,
      relatorio: JSON.stringify({
        formato: relatorio.formato,
        tituloRelatorio: relatorio.tituloRelatorio,
        textoPesquisa: relatorio.textoPesquisa,
        custom: relatorio.custom,
      }),
    };
  };

  const requestWithLegacyParams = () =>
    api.post(`${endpoint}/export`, axiosParams, {
      params: axiosParams,
      paramsSerializer: (requestParams) => qs.stringify(requestParams),
      responseType: 'blob',
    });

  const requestWithReducedQuery = () =>
    api.post(`${endpoint}/export`, qs.stringify(axiosParams), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      params: buildReducedQueryParams(),
      paramsSerializer: (requestParams) => qs.stringify(requestParams),
      responseType: 'blob',
    });

  let response;

  try {
    response = compactQuery
      ? await requestWithReducedQuery()
      : await requestWithLegacyParams();
  } catch (error) {
    if (!compactQuery && error?.response?.status === 400) {
      response = await requestWithReducedQuery();
    } else {
      throw error;
    }
  }

  // const blob = response.data;
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });

  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;

  if (formato === 'excel') {
    link.download = `${tituloRelatorio}.xls`;
  } else {
    link.target = '_blank';
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}

/**
 * 
 * Idem anterior, porem usa o metodo get
 * 
 * Função genérica para gerar e abrir um relatório em uma nova aba.
 * @param {object} options - Objeto de configurações.
 * @param {string} options.endpoint - O caminho específico da API para o
 * relatório.
 * @param {object} options.params - Um objeto contendo todos os parâmetros da
 * requisição para o backend. O objeto 'relatorio' dentro de 'params' será
 * JSON.stringified automaticamente. Os parâmetros devem ser assim:
 * const params = {
 *  fieldlist: 'id, nome, etc...', --> Obrigatório!
 *  wherefield: ['id', 'nome', etc...],
 *  typewherefield: ['EQUALS', 'EQUALS', etc..],
 *  valuewherefield: [1, 'Fulano', etc..],
 *  ... e todos os outros campos em buscaTodos
           relatorio: {
             formato, --> Obrigatório estar preenchido com 'pdf' ou 'excel' (
             Pode ser 'EXCEL' ou 'PDF')
             tituloRelatorio: 'Relatório', --> Obrigatório!
             substituirHeader: {
               nome: 'Quero outro header',
             },
           },
         };
 *
 */
export async function generateReportGet({ endpoint, params }) {
  const axiosParams = { ...params };

  if (
    !endpoint ||
    !axiosParams.relatorio ||
    !axiosParams.relatorio.formato ||
    (axiosParams.relatorio.formato.toLowerCase() !== 'pdf' &&
      axiosParams.relatorio.formato.toLowerCase() !== 'excel') ||
    !axiosParams.relatorio.tituloRelatorio ||
    !axiosParams.fieldlist
  ) {
    throw new Error(
      'Para gerar o relatório é necessário enviar o endpoint e os parâmetros ' +
        'fieldlist, e um objeto relatório com o formato e o título do mesmo!'
    );
  }

  const formato = axiosParams.relatorio.formato.toLowerCase();
  const { tituloRelatorio } = axiosParams.relatorio;

  if (axiosParams.relatorio.substituirHeader) {
    axiosParams.relatorio.substituirHeader = JSON.stringify(
      axiosParams.relatorio.substituirHeader
    );
  }

  axiosParams.relatorio = JSON.stringify(axiosParams.relatorio);

  const response = await api.get(endpoint, {
    params: axiosParams,
    paramsSerializer: (param) => qs.stringify(param),
    responseType: 'blob',
  });

  const blob = response.data;

  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;

  if (formato === 'excel') {
    link.download = `${tituloRelatorio}.xls`;
  } else {
    link.target = '_blank';
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}
